<template>
  <div>
    <v-row no-gutters class="mb-8 px-8">
      <v-col
        xs="0"
        sm="0"
        md="0"
        lg="1"
        xl="1"
      >
      </v-col>

      <v-col
        xs="12"
        sm="12"
        md="12"
        lg="10"
        xl="10"
        class="pt-8"
      >
        <div class="d-flex flex-column">
          <div class="d-flex mb-16 pb-8">
            <div class="text-h3 font-weight-light">
              {{ $t('menus.engine') }}
            </div>
            <v-spacer></v-spacer>
            <!-- <div class="font-weight-light">
              {{ now }}
            </div> -->
          </div>

          <v-row no-gutters>
            <v-col 
              xl="6"
              lg="7"
              md="12"
              sm="12"
              xs="12"
              class="d-flex flex-column align-center"
            >
              <div class="d-flex flex-column">
                <div class="text-h5 font-weight-light">
                  {{ $t('fxEngine.spotD2') }}
                </div>
                <div class="text--disabled font-weight-light">
                  {{ $t('fxEngine.lastUpdate') }} {{ marketdata.lastupdate }}
                </div>
              </div>
              <!-- <donut-chart></donut-chart> -->
               <div v-if="isMarketDataReady">
                 <v-simple-table
                   class="mt-4 mx-4 no-hover custom-table"
                   style="background-color: #121212;"
                 >
                   <tbody>
                     <!-- Row 1 - WDOJ24 -->
                     <tr>
                       <!-- ASK value -->
                       <td class="px-4 py-3 value-td">
                         <div class="text-h4 font-weight-bold">
                          {{ this.isMockDataOn ? mockedAskWdoj.toFixed(1).toString() : formatOneDecimal(marketdata.ask.wdo1) }}
                         </div>
                       </td>
                       <!-- ASK label -->
                       <td class="label-td">
                         <div class="text-body-2 text--secondary text-left">
                           <div class="font-weight-bold">{{ $t('fxEngine.WDOJ24') }}</div>
                           <div class="attention--text">{{ $t('fxEngine.ask') }}</div>
                         </div>
                       </td>
   
                       <!-- BID value -->
                       <td class="px-4 py-3 value-td">
                         <div class="text-h4 font-weight-bold">
                           {{ this.isMockDataOn ? mockedBidWdoj.toFixed(1).toString() : formatOneDecimal(marketdata.bid.wdo1) }}
                         </div>
                       </td>
                       <!-- BID label -->
                       <td class="label-td">
                         <div class="text-body-2 text--secondary text-left">
                           <div class="font-weight-bold">{{ $t('fxEngine.WDOJ24') }}</div>
                           <div class="alive--text">{{ $t('fxEngine.bid') }}</div>
                         </div>
                       </td>
                     </tr>
   
                     <!-- Row 2 - Casado (editable) -->
                     <tr>
                       <!-- ASK editable -->
                        <td class="px-4 py-3 value-td">
                         <div class="text-h4 font-weight-bold">
                           {{ formatOneDecimal(marketdata.ask.csd2) }}
                         </div>
                       </td>

                      <!-- If we keep the button, we don't need this text-field -->
                       <!-- <td class="px-4 py-3 value-td">
                         <v-text-field
                           :value="editableCasadoAsk"
                            hide-details
                            solo
                            type="text"
                            class="text-h4 font-weight-bold remove-spin centered-input"
                            @input="onCasadoAskInput"
                            @keydown="preventInvalidOverwrite"
                         />
                       </td> -->

                       <!-- ASK label -->
                      <td class="label-td">
                        <div class="d-flex align-center justify-space-between" style="width:100%">
                          <div class="text-body-2 text--secondary">
                            <div class="font-weight-bold">{{ $t('fxEngine.casadoUsd') }}</div>
                            <div class="attention--text">{{ $t('fxEngine.ask') }}</div>
                          </div>
                          <v-btn
                            icon
                            class="ml-2"
                            @click="editCasado('ask', marketdata.ask.csd2)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </div>
                      </td>
   
                       <!-- BID editable -->
                        <td class="px-4 py-3 value-td">
                          <div class="text-h4 font-weight-bold">
                           {{ formatOneDecimal(marketdata.bid.csd2) }}
                          </div>
                        </td>

                      <!-- Same: if we keep the button, we don't need this text-field -->
                       <!-- <td class="px-4 py-3 value-td">
                         <v-text-field
                           :value="editableCasadoBid"
                            hide-details
                            solo
                            type="text"
                            class="text-h4 font-weight-bold remove-spin centered-input"
                            @input="onCasadoBidInput"
                            @keydown="preventInvalidOverwrite"
                         />
                       </td> -->

                       <!-- BID label -->
                      <td class="label-td">
                        <div class="d-flex align-center justify-space-between" style="width:100%">
                          <div class="text-body-2 text--secondary">
                            <div class="font-weight-bold">{{ $t('fxEngine.casadoUsd') }}</div>
                            <div class="alive--text">{{ $t('fxEngine.bid') }}</div>
                          </div>
                          <v-btn
                            icon
                            class="ml-2"
                            @click="editCasado('bid', marketdata.bid.csd2)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </div>
                      </td>
                     </tr>
   
                     <!-- Row 3 - USDBRL -->
                     <tr>
                       <!-- ASK value -->
                       <td class="px-4 py-3 value-td">
                         <div class="text-h4 font-weight-bold">
                          {{ formattedCalc ("ask") }}                         
                         </div>
                       </td>
                       <!-- ASK label -->
                       <td class="label-td">
                         <div class="text-body-2 text--secondary text-left">
                           <div class="font-weight-bold">{{ $t('fxEngine.USDBRL') }}</div>
                           <div class="attention--text">{{ $t('fxEngine.ask') }}</div>
                         </div>
                       </td>

                       <!-- BID value -->
                       <td class="px-4 py-3 value-td">
                         <div class="text-h4 font-weight-bold">
                             {{ formattedCalc("bid") }}
                         </div>
                       </td>
                       <!-- BID label -->
                       <td class="label-td">
                         <div class="text-body-2 text--secondary text-left">
                           <div class="font-weight-bold">{{ $t('fxEngine.USDBRL') }}</div>
                           <div class="alive--text">{{ $t('fxEngine.bid') }}</div>
                         </div>
                       </td>
                     </tr>
                   </tbody>
                 </v-simple-table>
               </div>
              <div
                v-else
                class="loading-indicator d-flex justify-center align-center"
                style="height: 500px"
              >
                <v-progress-circular indeterminate color="primary" :size="110" :width="7"></v-progress-circular>
              </div>
            </v-col>

            <v-col 
              xl="6"
              lg="5"
              md="12"
              sm="12"
              xs="12"
              class="d-flex"
            >
              <v-divider vertical inset class="py-2" v-if="isXLarge || isLarge"></v-divider>

              <div class="d-flex flex-column mx-auto" style="max-width: 480px; height: 100%;">
                <div class="d-flex flex-column mb-8">
                  <div class="text-h5 font-weight-light">
                    {{ $t('fxEngine.operationalSummary').toUpperCase() }}
                  </div>
                  <div class="text--disabled font-weight-light">
                    {{ $t('fxEngine.lastSevenDays') }}
                  </div>
                </div>

                <div
                  class="my-auto d-flex flex-column fill-height"
                  style="justify-content: space-evenly;"
                >
                  <div class="text-h2 mt-0 ml-3 font-weight-light mb-4">
                    {{ dealCount }} <span class="text-subtitle-1 font-weight-light"> {{ $t('fxEngine.deals').toUpperCase() }} </span>
                  </div>

                  <div class="text-h2 mb-0 ml-3 font-weight-light d-flex align-center">
                    <!-- <div class="mr-3"> -->
                      <!-- <span class="text-subtitle-1 font-weight-light"> DEAL destination address 
                      <pre>{{ APIKEY }}</pre>
                      </span> -->
                    <!-- </div> -->

                    <v-text-field
                      v-model="dealDestinationAddress"
                      :label="$t('fxEngine.dealDestination')"
                      placeholder="address@email.com"
                      class="mr-2"
                      style="width: 220px;"
                      readonly
                      persistent-hint
                      :hint="$t('extras.readOnly')"
                    >
                    </v-text-field>

                      <!--
                    <v-btn
                      disabled
                      elevation="0"
                      tile
                      color="blue"
                    >
                      SAVE
                    </v-btn>
                      -->
                    <!-- <div class="mr-3">
                    </div> -->
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <v-col
        xs="0"
        sm="0"
        md="0"
        lg="1"
        xl="1"
      >
      </v-col>
    </v-row>
    

    <!-- SPREADS SECTION -->
    <v-row no-gutters>
      <v-col cols="12">
        <v-sheet
          width="100%"
          class="py-12 px-8"
        >
          <v-row no-gutters>
            <v-col
              xs="0"
              sm="0"
              md="0"
              lg="1"
              xl="1"
            >
            </v-col>

            <v-col
              xs="12"
              sm="12"
              md="12"
              lg="10"
              xl="10"
              class="pt-4 d-flex flex-column"
            >
              <div class="text-h5 font-weight-light mb-10">
                {{ $t('fxEngine.spreads.title') }}
              </div>

              <v-card outlined>
                <v-tabs
                  v-model="spreadsTab"
                  color="white"
                  slider-color="primary"
                  :slider-size="5"
                  style="border-bottom: 1px solid gray;"
                >
                  <!-- CATEGORIES TAB -->
                  <v-tab>
                    {{ $t('fxEngine.spreads.categories.title') }}
                    
                    <!--
                    <v-btn outlined 
                      small 
                      color="white"
                      disabled
                    >
                      <v-icon
                        left
                        color="white"
                      >
                        mdi-plus
                      </v-icon>
                      ADD CERTIFICATE
                    </v-btn>
                    -->
                  </v-tab>
                  <v-tab>
                    {{ $t('fxEngine.spreads.notional') }}

                    <!--
                    <v-btn outlined 
                      small 
                      color="white"
                      disabled
                    >
                      <v-icon
                        left
                        color="white"
                      >
                        mdi-plus
                      </v-icon>
                      ADD CERTIFICATE
                    </v-btn>
                    -->
                  </v-tab>
                </v-tabs>     

                <v-tabs-items v-model="spreadsTab">
                  <v-tab-item>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t('fxEngine.spreads.status.title') }}
                            </th>
                            <th class="text-left">
                              {{ $t('fxEngine.spreads.category') }}
                            </th>
                            <th 
                              class="text-left"
                            >
                              <!-- style="max-width: 400px; width: 400px" -->
                              {{ $t('fxEngine.spreads.valueBps') }}
                            </th>
                            <th class="text-left">
                              
                            </th>
                            <th class="text-left">
                              {{ $t('fxEngine.spreads.lastUpdate') }}
                            </th>
                            <th class="text-left">
                              
                            </th>
                            <th class="text-left">
                              {{ $t('fxEngine.spreads.edit.title').toUpperCase() }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in visibleSpreadCategory"
                            :key="index"
                            style="background-color: #121212;"
                          >
                            <td
                              :class="{
                                'green--text text--accent-4': item.status && item.status.toLocaleLowerCase() === 'active'
                              }"
                            >
                              {{ spreadStatus(item.status) }}
                            </td>
                            <td>{{item.label ?? spreadCategory(item.category)}}</td>
                            <td>{{ item.value }}</td>
                            <td>
                              <div class="d-flex flex-column">
                                <span>
                                  -
                                  <!-- {{ item.timecreate | formatTimeAndDate }} -->
                                </span>
                                <!-- <span class="text--disabled">
                                  {{ item.certificate_creation_date }}
                                </span> -->
                              </div>
                            </td>
                            <td>
                              <div class="d-flex flex-column">
                                <span>
                                  {{ formatTimeAndDate(item.timelast) }}
                                </span>
                                <!-- <span class="text--disabled">
                                  {{ item.last_connection_date }}
                                </span> -->
                              </div>
                            </td>
                            <td>
                              <div class="d-flex flex-column">
                                <span>
                                  -
                                  <!-- {{ item.timedue | formatTimeAndDate }} -->
                                </span>
                                <!-- <span class="text--disabled">
                                  {{ item.expiration_date }}
                                </span> -->
                              </div>
                            </td>
                            <td>
                              <v-btn
                                icon
                                :disabled="item.editable"
                                class="ml-3"
                                @click="editSpreadCategory(item)"
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-tab-item>

                  <!-- NOTIONAL TAB -->
                  <v-tab-item>
                    <v-simple-table style="border-top: 4px solid #121212;">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t('fxEngine.spreads.status.title') }}
                            </th>
                            <th class="text-left">
                              {{ $t('fxEngine.spreads.notional') }}
                            </th>
                            <th 
                              class="text-left"
                            >
                              <!-- style="max-width: 400px; width: 400px" -->
                              {{ $t('fxEngine.spreads.valueBps') }}
                            </th>
                            <th class="text-left">
                              
                            </th>
                            <th class="text-left">
                              {{ $t('fxEngine.spreads.lastUpdate') }}
                            </th>
                            <th class="text-left">
                              
                            </th>
                            <th class="text-left">
                              {{ $t('fxEngine.spreads.edit.title').toUpperCase() }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in visibleNotionCategory"
                            :key="index"
                            style="background-color: #121212;"
                          >
                            <td
                              :class="{
                                'green--text text--accent-4': item.status && item.status.toLocaleLowerCase() === 'active'
                              }"
                            >
                              {{ spreadStatus(item.status) }}
                            </td>
                            <td>{{ item.notional }}</td>
                            <td>{{ item.value }}</td>
                            <td>
                              <div class="d-flex flex-column">
                                <span>
                                  -
                                  <!-- {{ item.timecreate | formatTimeAndDate }} -->
                                </span>
                                <!-- <span class="text--disabled">
                                  {{ item.certificate_creation_date }}
                                </span> -->
                              </div>
                            </td>
                            <td>
                              <div class="d-flex flex-column">
                                <span>
                                  {{ formatTimeAndDate(item.timelast) }}
                                </span>
                                <!-- <span class="text--disabled">
                                  {{ item.last_connection_date }}
                                </span> -->
                              </div>
                            </td>
                            <td>
                              <div class="d-flex flex-column">
                                <span>
                                  -
                                  <!-- {{ item.timedue | formatTimeAndDate }} -->
                                </span>
                                <!-- <span class="text--disabled">
                                  {{ item.expiration_date }}
                                </span> -->
                              </div>
                            </td>
                            <td>
                              <v-btn
                                icon
                                :disabled="item.editable"
                                class="ml-3"
                                @click="editSpreadNotional(item)"
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>

            </v-col>

            <v-col
              xs="0"
              sm="0"
              md="0"
              lg="1"
              xl="1"
            >
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>

    <v-dialog v-model="showCasadoDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{ casadoDialogTitle }}
        </v-card-title>

        <v-card-text>
          <v-text-field
            :value="dialogCasadoValue"
            type="text"
            step="0.0001"
            dense
            outlined
            @input="onDialogCasadoInput"
            @keydown="preventInvalidOverwrite"
            @keyup.enter="saveCasado"
            class="remove-spin"
          />
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="cancelEditCasado">Cancel</v-btn>
          <v-btn color="primary" :loading="savingCasado" @click="saveCasado">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSpreadsCategory"
      max-width="500px"
      persistent
    >
      <v-card :disabled="loadingSpreadCategoryPut">
        <v-card-title>
          {{ spreadCategory(spreadCategoryPayload.category) }}
        </v-card-title>
        <v-card-text>
          <v-row class="mt-6">
            <v-col
              cols="12"
              sm="6"
              md="4"
            >
              <v-text-field
                type="number"
                hide-spin-buttons
                v-model="spreadCategoryPayload.value"
                :label="$t('fxEngine.spreads.edit.spread')"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
            >
              <div>
                <span class="text-caption">
                  {{ $t('fxEngine.spreads.edit.status') }}
                </span>
                <v-switch
                  class="mt-0"
                  v-model="spreadCategoryPayload.status"
                  :label="$t('fxEngine.spreads.edit.active')"
                ></v-switch>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialogSpreadsCategory = false"
          >
            {{ $t('instructions.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            tile
            @click="saveSpreadCategory()"
            :loading="loadingSpreadCategoryPut"
          >
            {{ $t('instructions.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSpreadsNotional"
      max-width="500px"
      persistent
    >
      <v-card :disabled="loadingSpreadNotionalPut">
        <v-card-title>
          {{ spreadNotionalPayload.notional }}
        </v-card-title>
        <v-card-text>
          <v-row class="mt-6">
            <v-col
              cols="12"
              sm="6"
              md="4"
            >
              <v-text-field
                type="number"
                hide-spin-buttons
                v-model="spreadNotionalPayload.value"
                :label="$t('fxEngine.spreads.edit.spread')"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
            >
              <div>
                <span class="text-caption">
                  {{ $t('fxEngine.spreads.edit.spread') }}
                </span>
                <v-switch
                  class="mt-0"
                  v-model="spreadNotionalPayload.status"
                  :label="$t('fxEngine.spreads.edit.active')"
                ></v-switch>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
            >
              <v-text-field
                :disabled= "true"
                type="number"
                hide-spin-buttons
                v-model="spreadNotionalPayload.notional"
                :label="$t('fxEngine.spreads.edit.notional')"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialogSpreadsNotional = false"
          >
            {{ $t('instructions.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            tile
            @click="saveSpreadNotional()"
            :loading="loadingSpreadNotionalPut"
          >
            {{ $t('instructions.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      color="green accent-4"
      :timeout="4000"
      bottom
    >
      <div class="black--text text-center">
        {{ $t('fxEngine.spreads.edit.updatedSuccess') }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { useDisplayStore, useAutopricerStore, useSettingsStore } from "./../store/index"
import { mapState, mapActions } from "pinia";
import * as utils from "./../utils.js"

export default {
  components: {
  },
  data () {
    const mockOn = useSettingsStore().isMockDataOn
    return {
      mockedAskWdoj:5830,
      mockedBidWdoj:5725,
      mockOn: mockOn,
      spreadsTab: 0,
      spreadsCategory: [],
      spreadsNotional: [],
      marketdata: {
        bid:{
          "wdo1": '',
          "csd2": '',
          "usdbrl": '',
        },
        ask:{
          "wdo1": '',
          "csd2": '',
          "usdbrl": '',
        },
        lastupdate: "-"
      },
      dealDestinationAddress: "",
      dealCount: 0,
      showCasadoDialog: false,
      dialogSide: 'ask',
      dialogField: 'csd2',
      savingCasado: false,
      dialogCasadoValue: null,
      dialogSpreadsCategory: false,
      dialogSpreadsNotional: false,
      spreadCategoryPayload: {
        value: undefined,
        status: undefined
      },
      spreadNotionalPayload: {
        value: undefined,
        status: undefined
      },
      loadingSpreadCategoryPut: false,
      loadingSpreadNotionalPut: false,
      snackbar: false,
      interval: null,
    }
  },
  mounted () {
    this.fetchMarketData()

    this.bankId = localStorage.getItem('bankId')
    this.interval = setInterval(() => {
      this.fetchMarketData()
      this.getDealCount(this.bankId)
        .then((response) => {
          const data = response.data
          this.dealCount = data.deal_count
        })
        .catch((error) => {
          console.log(error)
        })
    }, 3000)
    

    //to randomize WDOJ when mocked
    if(this.isMockDataOn)
    {
      setInterval(()=>{
        this.mockedAskWdoj = 5830 + (Math.random() * 20)
        this.mockedBidWdoj = 5725 + (Math.random() *25) 
        },3000)
    }
    this.spreadsCategoryFetch()
    this.spreadsNotionalFetch()
    this.dealDestinationAddress = localStorage.getItem('userEmail')
    
    // this.getDealEmailAddress()
    //   .then((response) => {
    //     const data = response.data
    //     this.dealDestinationAddress = data.deals_email_address
    //   })
    //   .catch((error) => {
    //     console.log(error)
    //   })
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  computed: {
    ...mapState(useDisplayStore, [
      "isXSmall",
      "isSmall",
      "isMedium",
      "isLarge",
      "isXLarge"
    ]),
    ...mapState(useSettingsStore, [
      "isMockDataOn",
    ]),
    currentAskWdo()
    { return this.isMockDataOn ? this.mockedAskWdoj : this.marketdata.ask.wdo1   },
    currentBidWdo()
    { return this.isMockDataOn ? this.mockedBidWdoj : this.marketdata.bid.wdo1   },
    visibleSpreadCategory() //control spreads when mockedOFF
    { return this.isMockDataOn ?   this.spreadsCategory : 
      (
        this.spreadsCategory.map((item,i)=>({...item, 
        status: i=== 0 ? item.status : "Skip",
        value: i=== 0 ? item.value : "0",
        editable: true
      })))  },
      visibleNotionCategory(){ //control notional when mockedOFF
        return this.isMockDataOn ? this.spreadsNotional : (
          this.spreadsNotional.map((item,i)=>({
            ...item,
            status: i === this.spreadsNotional.length-1 ? item.status : "Skip",
            value: i === this.spreadsNotional.length-1 ? item.value : "0",
            editable: true
          }))
        )
      },
    now () {
      return utils.getCurrentDateAndTime()
    },
    casadoDialogTitle () {
      return this.dialogSide === 'ask' ? 'Edit casado Ask' : 'Edit casado Bid'
    },
    isMarketDataReady() {
      const ask = this.marketdata?.ask
      const bid = this.marketdata?.bid

      const hasValidNumber = val =>
        val !== null && val !== undefined && val !== "" && !isNaN(Number(val)) && Number(val) !== 0

      return (
        hasValidNumber(ask?.wdo1) &&
        hasValidNumber(bid?.wdo1) &&
        hasValidNumber(ask?.usdbrl) &&
        hasValidNumber(bid?.usdbrl)
      )
    }
  },
  methods: {
    ...mapActions(useAutopricerStore, [
      "getMarketData",
      "getDealEmailAddress",
      "getDealCount",
      "getSpreadsCategory",
      "putDealEmailAddress",
      "putSpreadsCategory",
      "getSpreadsNotional",
      "putSpreadsNotional",
      "putCasado"
    ]),
     formattedCalc(side)
    {
      const wdo = side === "ask" ? this.currentAskWdo : this.currentBidWdo;     
      const casado = this.marketdata[side].csd2;
      return ((parseFloat(wdo) / 1000) - (parseFloat(casado) / 1000)).toFixed(4)
    },
    formatTimeAndDate (timestamp) {
      return utils.formatTimeAndDate(timestamp)
    },
    formatTime (timestamp) {
      return utils.formatTime(timestamp)
    },
    fetchMarketData () {
      const bankId = this.bankId
      return this.getMarketData(bankId)
        .then(response => {
          const data = response.data
          this.marketdata = data
          const lastUpdate = data.lastupdate
          this.marketdata.lastupdate = this.formatTime(lastUpdate)
        })
        .catch(err => console.log(err))
    },
    spreadsCategoryFetch () {
      this.getSpreadsCategory()
        .then((response) => {
          const data = response.data
          this.spreadsCategory = data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    spreadsNotionalFetch () {
      this.getSpreadsNotional()
        .then((response) => {
          const data = response.data
          this.spreadsNotional = data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    editCasado (side, value) {
      this.dialogSide = side
      const casado = value == null ? '' : Number(value).toFixed(1)
      this.dialogCasadoValue = casado
      this.showCasadoDialog = true
    },
    onDialogCasadoInput (event) {
      const val = typeof event === 'string' ? event : event?.target?.value
      this.dialogCasadoValue = this.normalizeInput(val || '')
    },
    saveCasado () {
      const n = Number(this.dialogCasadoValue)
      if (isNaN(n)) return

      this.marketdata[this.dialogSide][this.dialogField] = n
      this.showCasadoDialog = false
      this.savingCasado = true

      const bankId = this.bankId
      this.putCasado(this.dialogSide, this.dialogField, n, bankId)
        .then(() =>
          this.fetchMarketData(),
          this.snackbar = true
        )
        .catch(err => console.log(err))
        .finally(() => { this.savingCasado = false })
    },
    cancelEditCasado () {
      this.showCasadoDialog = false
    },
    editSpreadCategory (item) {
      this.spreadCategoryPayload = JSON.parse(JSON.stringify(item))
      let status = false
      if (this.spreadCategoryPayload.status === "Active") {
        status = true
      }
      this.spreadCategoryPayload.status = status
      this.dialogSpreadsCategory = true
    },
    editSpreadNotional (item) {
      this.spreadNotionalPayload = JSON.parse(JSON.stringify(item))
      let status = false
      if (this.spreadNotionalPayload.status === "Active") {
        status = true
      }
      this.spreadNotionalPayload.status = status
      this.dialogSpreadsNotional = true
    },
    saveSpreadCategory () {
      const payload = JSON.parse(JSON.stringify(this.spreadCategoryPayload))
      let status = "Skip"
      if (payload.status) {
        status = "Active"
      }
      payload["status"] = status
      payload["value"] = Number(payload["value"])
      this.loadingSpreadCategoryPut = true
      this.putSpreadsCategory(payload)
        .then(() => {
          this.snackbar = true
          this.spreadsCategoryFetch()
          this.dialogSpreadsCategory = false
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.loadingSpreadCategoryPut = false
        })
    },
    saveSpreadNotional () {
      const payload = JSON.parse(JSON.stringify(this.spreadNotionalPayload))
      let status = "Skip"
      if (payload.status) {
        status = "Active"
      }
      payload["status"] = status
      payload["value"] = Number(payload["value"])
      this.loadingSpreadNotionalPut = true
      this.putSpreadsNotional(payload)
        .then(() => {
          this.snackbar = true
          this.spreadsNotionalFetch()
          this.dialogSpreadsNotional = false
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.loadingSpreadNotionalPut = false
        })
    },
    spreadStatus (status) {
      if (status.toLowerCase() === 'active') {
        return this.$i18n.t('fxEngine.spreads.status.active')
      }
      else {
        return this.$i18n.t('fxEngine.spreads.status.skip')
      }
    },
    spreadCategory (category) {
      if (category === 'COMERCIO_EXTERIOR') {
        return this.$i18n.t('fxEngine.spreads.categories.foreignTrade')
      }
      else if (category === 'CAPITAIS_ESTRANGEIROS') {
        return this.$i18n.t('fxEngine.spreads.categories.foreignCapital')
      }
      else if (category === 'RENDAS_CAPITAIS') {
        return this.$i18n.t('fxEngine.spreads.categories.capitalGains')
      }
      else if (category === 'SEGUROS') {
        return this.$i18n.t('fxEngine.spreads.categories.insurance')
      }
      else if (category === 'SERVICOS_DIVERSOS') {
        return this.$i18n.t('fxEngine.spreads.categories.micellaneousServices')
      }
      else {
        return this.$i18n.t('fxEngine.spreads.categories.transport')
      }
    },
    formatOneDecimal(value) {
      const num = parseFloat(value)
      if (isNaN(num)) return '-'

      const rounded = Number(num.toFixed(1))

      return rounded.toLocaleString('en-US', {
        minimumFractionDigits: 1, 
        maximumFractionDigits: 1,
        useGrouping: false
      })
    },
    normalizeInput(val) {
      const numeric = val.replace(/\D/g, '')
      if (!numeric) return ''
      const asNumber = parseFloat(numeric) / 10
      return asNumber.toFixed(1)
    },
    preventInvalidOverwrite(event) {
      const isDigit = /^[0-9]$/.test(event.key)
      const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab']
      const ctrlCombo = event.ctrlKey || event.metaKey

      if (!isDigit && !allowed.includes(event.key) && !ctrlCombo) {
        event.preventDefault()
      }
    }
  }
}
</script>

<style scoped>
  .remove-spin >>> input[type="number"] {
    -webkit-appearance: none; /* Chrome, Safari, Edge */
    -moz-appearance: textfield; /* Firefox */
    appearance: textfield; /* Outros navegadores */
  }
  
  .remove-spin >>> input[type="number"]::-webkit-inner-spin-button,
  .remove-spin >>> input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

.no-hover tbody tr:hover {
  background-color: unset !important;
}

.custom-table >>> table,
.custom-table >>> th,
.custom-table >>> td {
  border: none !important;
  border-collapse: collapse;
  padding: 0.5rem 0.75rem;
}

td {
  white-space: nowrap;
}

.label-td {
  min-width: 80px;
}

.value-td {
  min-width: 150px;
}

/* .value-td >>> div {
  background-color: #1e1e1e;
  border-radius: 4px;
  padding: 4px 8px;
  text-align: center
} */
</style>
